import React from 'react';
import { ChevronDown, ChevronUp, MapPin } from 'lucide-react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';

const LocationTimeSection = ({ expanded, onToggle, formData, setFormData }) => {
  return (
    <div className="bg-white rounded-lg border border-gray-200">
      <div 
        className="flex items-center justify-between p-4 cursor-pointer hover:bg-gray-50"
        onClick={onToggle}
      >
        <div className="flex items-center gap-3">
          <MapPin className="w-5 h-5 text-blue-600" />
          <h2 className="text-lg font-semibold text-gray-900">
            Location & Time Details <span className="text-red-600">*</span>
          </h2>
        </div>
        {expanded ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
      </div>
      {expanded && (
        <div className="p-4 pt-0 border-t border-gray-200">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Primary Location <span className="text-red-600">*</span>
              </label>
              <Select
                value={formData?.location}
                onChange={(val) => setFormData(prev => ({ ...prev, location: val }))}
                placeholder="Select location"
                required
                options={[
                  { value: 'Manufacturing Plant A', label: 'Manufacturing Plant A' },
                  { value: 'Warehouse B', label: 'Warehouse B' },
                  { value: 'Construction Site C', label: 'Construction Site C' },
                  { value: 'Laboratory', label: 'Laboratory' },
                  { value: 'Office Building', label: 'Office Building' },
                  { value: 'Vehicle/Transport', label: 'Vehicle/Transport' },
                ]}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Specific Area
              </label>
              <Input
                value={formData?.specificArea}
                onChange={(e) => setFormData(prev => ({ ...prev, specificArea: e?.target?.value }))}
                placeholder="e.g., Assembly Line 3, Loading Bay 2"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Incident Date <span className="text-red-600">*</span>
              </label>
              <Input
                type="date"
                value={formData?.incidentDate}
                onChange={(e) => setFormData(prev => ({ ...prev, incidentDate: e?.target?.value }))}
                max={new Date()?.toISOString()?.split('T')?.[0]}
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Incident Time <span className="text-red-600">*</span>
              </label>
              <Input
                type="time"
                value={formData?.incidentTime}
                onChange={(e) => setFormData(prev => ({ ...prev, incidentTime: e?.target?.value }))}
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Date Reported
              </label>
              <Input
                type="date"
                value={formData?.reportedDate}
                disabled
                className="bg-gray-50"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Time Reported
              </label>
              <Input
                type="time"
                value={formData?.reportedTime}
                disabled
                className="bg-gray-50"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LocationTimeSection;